exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fans-manage-time-tips[data-v-5c238195] {\n  margin-left: 10px;\n  color: #f56c6c;\n  font-size: 14px;\n}\n.fans-manage-range[data-v-5c238195] {\n  margin-bottom: 40px;\n}\n.fans-manage-range .el-slider[data-v-5c238195] {\n  white-space: nowrap;\n}\n.fans-manage-order[data-v-5c238195] {\n  width: 80px;\n}\n.fans-manage-item + div[data-v-5c238195] {\n  margin-top: 22px;\n}\n", ""]);

// exports
